module.exports = __webpack_public_path__ + "img/wechat-video.5d094bd6.jpg";